import { pathToRegexp, compile } from 'path-to-regexp'
import isEmpty from 'lodash/isEmpty.js'
import { createAxiosChain } from './axios-chain.js'
import Axios from 'axios'
const { create: axiosCreate } = Axios

const schema = {
  getLineSignUp: {
    method: 'get',
    path: '/_/sign-up/line'
  },
  makeLineSignUp: {
    method: 'post',
    path: '/_/sign-up/line',
    transform (payload) {
      return { data: payload }
    }
  },

  getAuthState: {
    method: 'get',
    path: '/_/auth/state'
  },

  signOut: {
    method: 'get',
    path: '/_/sign-out'
  },

  getNotificationStat: {
    method: 'get',
    path: '/_/notification'
  },
  takeNotification: {
    method: 'post',
    path: '/_/notification',
    transform ({
      latestTotalCount,
      cursor,
      limit
    }) {
      return {
        data: {
          latestTotalCount,
          cursor,
          limit
        }
      }
    }
  },
  readNotification: {
    method: 'put',
    path: '/_/notification',
    transform ({
      id
    }) {
      return {
        data: {
          id
        }
      }
    }
  },

  createPointGive: {
    method: 'post',
    path: '/_/point/give',
    transform (payload) {
      return { data: payload }
    }
  },
  getPointGive: {
    method: 'get',
    path: '/_/p/:key',
    transform ({ key }) {
      return { params: { key } }
    }
  },
  takePointGive: {
    method: 'post',
    path: '/_/p/:key',
    transform ({ key }) {
      return { params: { key } }
    }
  },

  getGift: {
    method: 'get',
    path: '/_/gift/:code',
    transform ({ code }) {
      return { params: { code } }
    }
  },
  takeGift: {
    method: 'post',
    path: '/_/gift/:code',
    transform ({ code }) {
      return { params: { code } }
    }
  },

  getPageContent: {
    method: 'get',
    path: '/_/page/:path',
    transform ({ path }) {
      return { params: { path } }
    }
  },

  listEvents: {
    method: 'get',
    path: '/_/events'
  },
  getEvent: {
    method: 'get',
    path: '/_/event/:sid',
    transform ({ sid }) {
      return {
        params: { sid }
      }
    }
  },
  getEventContent: {
    method: 'get',
    path: '/_/event/:id/content',
    transform ({ id, redeemCode, eventTogetherKey }) {
      return {
        params: { id },
        query: { redeem: redeemCode, together: eventTogetherKey }
      }
    }
  },

  refreshLineFriendship: {
    method: 'get',
    path: '/_/auth/line/friendship'
  },
  getEventAttended: {
    method: 'get',
    path: '/_/event/:id/attended',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  signupEvent: {
    method: 'post',
    path: '/_/event/:id',
    transform ({ id, eventTogetherKey }) {
      return {
        params: { id },
        query: { eventTogetherKey },
        data: {}
      }
    }
  },
  redeemEvent: {
    method: 'post',
    path: '/_/event/:id/redeem',
    transform ({ id, code }) {
      return { params: { id }, data: { code } }
    }
  },
  attendEvent: {
    method: 'post',
    path: '/_/event/:id/attend',
    transform ({ id, attendTicket }) {
      return { params: { id }, data: { attendTicket } }
    }
  },
  createEventTogether: {
    method: 'post',
    path: '/_/event/:id/together',
    transform ({ id }) {
      return { params: { id }, data: {} }
    }
  },
  acceptEventTogether: {
    method: 'put',
    path: '/_/event/:id/together',
    transform ({ id, key }) {
      return { params: { id }, query: { key } }
    }
  },
  cancelEventTogether: {
    method: 'delete',
    path: '/_/event/:id/together',
    transform ({ id, key, member }) {
      return {
        params: { id },
        query: { key, member }
      }
    }
  },

  listEventCpiFile: {
    method: 'get',
    path: '/_/event/:id/cpi',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  getEventFlippedFile: {
    method: 'get',
    path: '/_/event/:id/cpi/:to',
    transform ({ id, to }) {
      return { params: { id, to } }
    }
  },

  listEventFlippedMember: {
    method: 'get',
    path: '/_/event/:id/flipped-member',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  createEventFlipped: {
    name: 'createEventFlipped',
    method: 'post',
    path: '/_/event/:id/flipped',
    transform ({ id, to }) {
      return { params: { id }, data: { to } }
    }
  },

  submitMatchFocus: {
    method: 'post',
    path: '/_/event/:id/focus',
    transform ({ id, minds }) {
      return { params: { id }, data: { minds } }
    }
  },
  listMatchFocusMember: {
    method: 'get',
    path: '/_/event/:id/match-focus/member',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  getMatchFocusReport: {
    method: 'get',
    path: '/_/event/:id/match-focus/report',
    transform ({ id }) {
      return { params: { id } }
    }
  },

  getQuestionnaire: {
    method: 'get',
    path: '/_/questionnaire/:id',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  submitQuestionnaire: {
    method: 'post',
    path: '/_/q/:id',
    transform ({ id, answers, eventSid }) {
      return {
        params: { id },
        query: { eventSid },
        data: { answers }
      }
    }
  },
  getQuestionnaireResult: {
    method: 'get',
    path: '/_/q/:id/result',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  getMyQuestionnaireSubmit: {
    method: 'get',
    path: '/_/q/:id/submit',
    transform ({ id }) {
      return { params: { id } }
    }
  },

  getLatestQuestionnairePuzzle: {
    method: 'get',
    path: '/_/questionnaire/:id/puzzle',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  drawQuestionnairePuzzle: {
    method: 'get',
    path: '/_/questionnaire/:id/draw',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  updateProfile: {
    method: 'patch',
    path: '/_/profile',
    transform (payload) {
      return { data: payload }
    }
  },
  getProfileJobInfo: {
    method: 'get',
    path: '/_/profile/jobInfo'
  },
  updateProfileJobInfo: {
    method: 'post',
    path: '/_/profile/jobInfo',
    transform (payload) {
      return { data: payload }
    }
  },
  getChristianInfo: {
    method: 'get',
    path: '/_/profile/christianInfo'
  },
  updateChristianInfo: {
    method: 'post',
    path: '/_/profile/christianInfo',
    transform (payload) {
      return { data: payload }
    }
  },
  updateProfileAvatar: {
    method: 'post',
    path: '/_/profile/avatar',
    transform ({ formData }) {
      return { data: formData }
    }
  },
  getMyPoint: {
    method: 'get',
    path: '/_/my/point'
  },

  listMyPointRecord: {
    method: 'get',
    path: '/_/my/point/record/:unixtime*',
    transform ({ unixtime }) {
      return { params: { unixtime } }
    }
  },

  donateOnce: {
    method: 'post',
    path: '/_/donate/:amount',
    transform ({ amount, back }) {
      return {
        params: { amount },
        query: { back }
      }
    }
  },
  donatePeriod: {
    method: 'post',
    path: '/_/donate/:amount/:times',
    transform ({ amount, times, back }) {
      return {
        params: { amount, times },
        query: { back }
      }
    }
  },

  getNetworkInfo: {
    method: 'get',
    path: '/_/network/info'
  },

  listEventStarPuzzleNotYetJoined: {
    method: 'get',
    path: '/_/event/:sid/star-puzzle/not-yet-joined',
    transform ({ sid }) {
      return { params: { sid } }
    }
  },
  getEventStarPuzzlePlayer: {
    method: 'get',
    path: '/_/event/:sid/star-puzzle/player',
    transform ({ sid }) {
      return { params: { sid } }
    }
  },
  updateEventStarPuzzleGamePlayerState: {
    method: 'put',
    path: '/_/event/:sid/star-puzzle/player/state',
    transform ({ sid, state }) {
      return { params: { sid }, data: { state } }
    }
  },

  listEventStarPuzzlePlayer: {
    method: 'get',
    path: '/_/event/:sid/star-puzzle/players',
    transform ({ sid }) {
      return { params: { sid } }
    }
  },

  getEventStarPuzzleGameGroup: {
    method: 'get',
    path: '/_/event-star-puzzle-game-group/:id',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  matchEventStarPuzzleGameGroup: {
    method: 'post',
    path: '/_/event-star-puzzle-game-group/:id/match',
    transform ({ id, code }) {
      return { params: { id }, data: { code } }
    }
  },
  getEventStarPuzzleGameGroupMatchedLogs: {
    method: 'get',
    path: '/_/event-star-puzzle-game-group/:id/matched-logs',
    transform ({ id }) {
      return { params: { id } }
    }
  },

  getEventStarPuzzleGameGroupEventTimePage: {
    method: 'get',
    path: '/_/event-star-puzzle-game-group/:id/event-time-page',
    transform ({ id }) {
      return { params: { id } }
    }
  },

  listEventStarPuzzleGameGroupFocusTarget: {
    method: 'get',
    path: '/_/star-puzzle-game-group/:id/focus-target',
    transform ({ id }) {
      return { params: { id } }
    }
  },
  listEventStarPuzzleFocusDraft: {
    method: 'get',
    path: '/_/event/:sid/star-puzzle/focus/draft',
    transform ({ sid }) {
      return { params: { sid } }
    }
  },
  createEventStarPuzzleFocusDraft: {
    method: 'post',
    path: '/_/star-puzzle-game-group/:id/focus/draft',
    transform ({ id, minds }) {
      return { params: { id }, data: { minds } }
    }
  },

  patchEventStarPuzzleGameGroup: {
    method: 'patch',
    path: '/_/event-star-puzzle-game-group/:id',
    transform ({ id, chatTopicIndex }) {
      return { params: { id }, data: { chatTopicIndex } }
    }
  },

  listEventStarPuzzleFocusTarget: {
    method: 'get',
    path: '/_/event/:sid/star-puzzle/focus-target',
    transform ({ sid }) {
      return { params: { sid } }
    }
  },
  createEventStarPuzzleMatchFocusSubmit: {
    method: 'post',
    path: '/_/event/:sid/star-puzzle/match-focus',
    transform ({ sid, minds }) {
      return { params: { sid }, data: { minds } }
    }
  },

  getEventStarPuzzleMatchFocusResult: {
    method: 'get',
    path: '/_/event/:sid/star-puzzle/match-focus/result',
    transform ({ sid }) {
      return { params: { sid } }
    }
  }

}

function createURLSearchParams (queryParams) {
  const searchParams = new URLSearchParams()
  if (typeof queryParams !== 'object') {
    return searchParams
  }

  for (const key in queryParams) {
    const params = queryParams[key]
    if (Array.isArray(params)) {
      for (const param of params) {
        if (typeof param !== 'undefined') {
          searchParams.append(key, param)
        }
      }
    } else {
      if (typeof params !== 'undefined') {
        searchParams.append(key, params)
      }
    }
  }

  return searchParams
}

const createAxios = function (baseURL) {
  return axiosCreate({
    baseURL,
    headers: {
      common: {}
    }
  })
}

function defineRequest (axios, { path, method }) {
  if (!method) {
    throw new Error('method is require')
  }

  if (!path) {
    throw new Error('path is require')
  }

  const keys = []
  pathToRegexp(path, keys)
  const toPath = compile(path)
  return function ({ query, params, data } = {}) {
    const path = toPath(params)

    if (isEmpty(query)) {
      const url = path
      return createAxiosChain({ axios, method, url, data })
    }

    const search = createURLSearchParams(query).toString()
    let url = `${path}`
    if (search) {
      url += `?${search}`
    }
    return createAxiosChain({ axios, method, url, data })
  }
}

function createDispatch (request, { transform }) {
  return async function (payload) {
    let config = {}
    if (transform) {
      config = transform(payload)
    }

    const { data } = await request(config)
    return data
  }
}

export const createRpcapi = function (baseURL) {
  const axios = createAxios(baseURL)

  const rpcapi = {}
  for (const name of Object.keys(schema)) {
    const { method, path, transform } = schema[name]
    rpcapi[name] = createDispatch(defineRequest(axios, { method, path }), { transform })
  }
  return rpcapi
}
